/** @jsxImportSource @emotion/react */
import React from 'react'
import { AboutUsForm, AboutUsPreview } from '../../../components/templates'
import * as styles from '../index.styles'
import Provider from '../../../context/AboutUsContext'
import { breadcrumbItems } from '../../utils'

const { index, contentManagement, aboutUsManagement } = breadcrumbItems

const AboutUsCreate: React.FC = () => {
  return (
    <Provider>
      <div css={styles.root}>
        <div css={styles.main}>
          <AboutUsForm />
        </div>
        <div css={styles.right}>
          <AboutUsPreview />
        </div>
      </div>
    </Provider>
  )
}

export default AboutUsCreate;
